import { applicationPaths } from '@core/http/applicationPaths';
import httpClient from '@core/http/httpClient';
import { EntityReducers } from '@core/store/EntityReducer';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { PreferencesModel, PreferencesFormModel } from '@shared/models';
import { AxiosResponse } from 'axios';

const getPreferences = createAsyncThunk(`${EntityReducers.preferences}/getPreferences`, async () => {
  const response: AxiosResponse<PreferencesModel> = await httpClient.get(applicationPaths.preferences.preferences);

  return response.data;
});

const savePreferences = createAsyncThunk(
  `${EntityReducers.preferences}/savePreferences`,
  async ({ body }: { body: PreferencesFormModel }) => {
    const response: AxiosResponse = await httpClient.put(applicationPaths.preferences.preferences, body);

    return response.data;
  }
);

export const thunks = { getPreferences, savePreferences };
